// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OWws","title":"Info_title__3iDoY","selects":"Info_selects__G5x7Q","requiredAsterisk":"Info_requiredAsterisk__1waaE"};